// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../../graphql/api/index';

export const QuestionnaireConditionIsGreaterThanFragmentDoc = `
    fragment questionnaireConditionIsGreaterThan on QuestionnaireConditionIsGreaterThan {
  __typename
  question {
    id
  }
  value
}
    `;